import { render, staticRenderFns } from "./SectionsSelect.vue?vue&type=template&id=85805336&"
import script from "./SectionsSelect.vue?vue&type=script&lang=js&"
export * from "./SectionsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports